import { createSetWidgetCapabilitiesMessage } from 'calling-global-api/lib/internalEventMessageCreators';
import { postInternalMessage } from '../initialize';
import { GLOBAL_NAME } from '../constants/Globals';
export default function setCapabilitiesHandler(capabilities) {
  const message = createSetWidgetCapabilitiesMessage(capabilities);
  postInternalMessage(message);
  window[GLOBAL_NAME].capabilities = capabilities;
}